import React from "react";
import Tooltip from "../tooltip.jsx";
import { IS_MOBILE } from "../../../util";

class VirtualScreeningIcon extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };
  }

  render() {
    let { styles, scale, color, disabled, useTooltip, rightAlign } = this.props;
    const scaleValue = scale ? "scale(" + scale + ")" : "scale(1.0)";
    const iconStyles = Object.assign(
      {
        position: "relative",
        color: color ? color : null,
        fill: "currentColor",
        fillOpacity: disabled ? 0.54 : 1.0
      },
      styles
    );
    if (useTooltip === undefined) {
      useTooltip = true;
    }

    const onMouseEnter = !IS_MOBILE
      ? () => this.setState({ hovered: true })
      : undefined;
    const onMouseLeave = !IS_MOBILE
      ? () => this.setState({ hovered: false })
      : undefined;

    return (
      <div
        style={iconStyles}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {useTooltip ? (
          <Tooltip
            containerStyle={
              rightAlign
                ? {
                    position: "relative",
                    paddingTop: 1,
                    overflow: "visible"
                  }
                : {}
            }
            show={this.state.hovered}
            style={rightAlign ? { marginLeft: 30, overflow: "visible" } : null}
            label="Virtual screening"
          />
        ) : null}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 26 26"
          width="24px"
          fill="currentColor"
        >
          <g transform={scaleValue}>
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z" />
          </g>
        </svg>
      </div>
    );
  }
}

export default VirtualScreeningIcon;



// WEBPACK FOOTER //
// ./src/app/components/partials/icons/virtual-screening-icon.jsx